// src/store/index.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../api/apiService'; // <-- important: uses interceptor
import { useProductDataStore } from '../state/useProductDataStore';

const useStore = create(
  persist(
    (set, get) => ({
      // AUTH
      accessToken: null,
      refreshToken: null,
      user: null,

      setAuth: ({ accessToken, refreshToken, user }) =>
        set((state) => ({
          accessToken,
          refreshToken,
          user: user !== undefined ? user : state.user,   // <--- preserve user!
        })),

      setUser: (user) => {
        console.log('setUser user', user);
        set({ user: user });
        return user;
      },

      logout: () => {
        set({ accessToken: null, refreshToken: null, user: null });
        localStorage.removeItem('admin-portal-storage');
        useProductDataStore.getState().clearAllData();
      },

      // DASHBOARD & FILTERS (from old Redux)
      dashboard: { stats: null, recentProducts: [] },
      setDashboard: (payload) => set((s) => ({ dashboard: { ...s.dashboard, ...payload } })),

      filter: { search: '', category: '', priceRange: [0, 1000] },
      setFilters: (payload) => set((s) => ({ filter: { ...s.filter, ...payload } })),
      setPeriod: (newPeriod) => set((s) => ({ period: newPeriod })),
      setDateRange: (newDateRange) => set((s) => ({ dateRange: newDateRange })),
      // TOKEN REFRESH
      refreshUserToken: async () => {
        const { refreshToken } = get();
        if (!refreshToken) return false;

        try {
          const res = await api.post('/auth/token/refresh/', { refresh: refreshToken });
          console.log('refreshUserToken response', res.data.access);
          set({ accessToken: res.data.access });

          console.log('refreshUserToken accessToken', get().accessToken);
          console.log('refreshUserToken user', get().user);
          console.log('refreshUserToken refreshToken', get().refreshToken);

          return true;
        } catch {
          get().logout();
          return false;
        }
      },
    }),
    {
      name: 'admin-portal-storage',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        dashboard: state.dashboard,
        filter: state.filter,
        user: state.user,
      }),
    }
  )
);

export default useStore;